import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCcJiwzgZ-QuaThInV49a0LG4O62cezjcg",
    authDomain: "vbsopcast.firebaseapp.com",
    databaseURL: "https://vbsopcast.firebaseio.com",
    projectId: "vbsopcast",
    storageBucket: "vbsopcast.appspot.com",
    messagingSenderId: "779442263783",
    appId: "1:779442263783:web:e882c3122a0f18cdd57442"
};

const app = initializeApp(firebaseConfig);
const firebase = getDatabase(app);
const auth = getAuth(app);
//firebase.enableLogging(false);
export default firebase;